"use client";

import React from "react";
import clsx from "clsx";

interface BorderedHeadingProps {
  children: React.ReactNode;
  className?: string;
  borderColor?: string;
  borderWidth?: number;
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "div";
  variant?:
    | "headline-1"
    | "headline-2"
    | "headline-3"
    | "headline-4"
    | "body-1-heavy"
    | "section-name";
}

const BorderedHeading: React.FC<BorderedHeadingProps> = ({
  children,
  className,
  borderColor,
  borderWidth = 3,
  as: Component = "div",
  variant = "headline-4",
}) => {
  const isSectionName = variant === "section-name";
  return (
    <Component
      className={clsx(
        "relative pl-4 md:pl-6 text-white",
        !isSectionName && variant,
        isSectionName &&
          "font-[var(--font-avenir)] font-bold text-[30px] leading-[42px] md:text-[42px] md:leading-[60px] lg:text-[55px] lg:leading-[79px]",
        className
      )}
      style={{
        borderLeft: `${isSectionName ? 5 : borderWidth}px solid ${
          borderColor || "var(--color-primary)"
        }`,
      }}
    >
      {children}
    </Component>
  );
};

export default BorderedHeading;
export { BorderedHeading };
